import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3c82f9d3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c82f9d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\baby_doctor_platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c82f9d3')) {
      api.createRecord('3c82f9d3', component.options)
    } else {
      api.reload('3c82f9d3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3c82f9d3&scoped=true", function () {
      api.rerender('3c82f9d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/colorText/index.vue"
export default component.exports